
import React from "react";
import Layout from "@/components/Layout";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

const Pricing = () => {
  const { user } = useAuth();
  
  const features = [
    "Acesso a todos os prompts",
    "Atualizações mensais com novos prompts",
    "Exemplos práticos para cada prompt",
    "Suporte por email",
    "Estatísticas de uso personalizado",
    "Acesso ilimitado a todos os recursos"
  ];

  const buttonText = user ? "Acessar Dashboard" : "Começar Agora";
  const buttonLink = user ? "/dashboard" : "/auth/register";

  return (
    <Layout>
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-3xl md:text-4xl font-bold font-display mb-4">Acesso 100% Gratuito</h1>
            <p className="text-gray-600 max-w-xl mx-auto">
              Todos os recursos da nossa plataforma estão disponíveis gratuitamente para nossos usuários.
            </p>
          </div>

          <div className="max-w-lg mx-auto">
            <div className="bg-white rounded-xl shadow-lg overflow-hidden transform transition-all hover:scale-105 border-2 border-lawyer-secondary">
              <div className="bg-lawyer-secondary text-white text-center py-2 text-sm font-medium">
                Acesso Total
              </div>
              <div className="p-8 text-center border-b border-gray-100">
                <h3 className="text-lawyer-primary font-semibold text-xl mb-2">Plano Completo</h3>
                <div className="flex items-center justify-center">
                  <span className="text-4xl font-bold text-lawyer-primary">Gratuito</span>
                </div>
                <p className="text-gray-600 mt-2">Para aumentar sua produtividade</p>
              </div>
              <div className="p-8">
                <ul className="space-y-4 mb-8">
                  {features.map((feature, idx) => (
                    <li key={idx} className="flex items-center">
                      <Check className="h-5 w-5 text-lawyer-secondary mr-3 flex-shrink-0" />
                      <span className="text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
                <Link
                  to={buttonLink}
                  className="w-full block text-center py-3 px-6 rounded-md font-medium transition-colors bg-lawyer-secondary hover:bg-lawyer-gold text-white"
                >
                  {buttonText}
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-16 text-center">
            <h3 className="text-xl font-bold mb-3">Perguntas Frequentes</h3>
            <div className="max-w-3xl mx-auto mt-8 space-y-6 text-left">
              <div className="p-5 border border-gray-200 rounded-lg bg-white">
                <h4 className="font-medium text-lg mb-2">O que inclui o acesso gratuito?</h4>
                <p className="text-gray-600">Nossa plataforma oferece acesso completo a todos os prompts e recursos sem nenhuma limitação. Tudo que você precisa para otimizar seu trabalho jurídico está disponível gratuitamente.</p>
              </div>
              <div className="p-5 border border-gray-200 rounded-lg bg-white">
                <h4 className="font-medium text-lg mb-2">Preciso pagar para usar os prompts avançados?</h4>
                <p className="text-gray-600">Não, todos os prompts, incluindo os avançados, são completamente gratuitos para uso. Não há recursos pagos ou limitados em nossa plataforma.</p>
              </div>
              <div className="p-5 border border-gray-200 rounded-lg bg-white">
                <h4 className="font-medium text-lg mb-2">Como vocês mantêm a plataforma sendo gratuita?</h4>
                <p className="text-gray-600">Nossa missão é democratizar o acesso a ferramentas de IA para profissionais jurídicos. Mantemos a plataforma com recursos próprios e parcerias estratégicas.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default Pricing;
